import React from 'react';
import { Spinner as ChakraSpinner, SpinnerProps as ChakraSpinnerProps } from '@chakra-ui/react';

export function Spinner(props: ChakraSpinnerProps) {
  return <ChakraSpinner speed={'0.40s'} {...props} />;
}
